import React from 'react';

export const Loading = () => (
  <div className="Loading">
    <img src="https://s3-eu-west-1.amazonaws.com/stktk-public/img/preloader.gif" alt="Loading" />
  </div>
);

export default React.memo(Loading);